type GeneralObject = Record<string, any>;

export default function deepOrderObj<T = any>(obj: T): T {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) return obj.map(item => deepOrderObj(item)) as T;

  if (obj instanceof Date) return obj;

  const sortedObj: GeneralObject = {};
  const keys = Object.keys(obj as object).sort();

  for (const key of keys) {
    sortedObj[key] = deepOrderObj((obj as Record<string, any>)[key]);
  }

  return sortedObj as T;
}
